var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import RcSteps from "rc-steps";
import classNames from "classnames";
import s from "./Steps.module.css";
import { Check } from "@components/icons";
var Steps = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var stepsClassName = classNames(s.root, className);
    var icons = {
        finish: _jsx(Check, {}, void 0),
        error: _jsx("p", { children: "error" }, void 0),
    };
    return (_jsx(RcSteps, __assign({ icons: icons }, props, { prefixCls: "cls", className: stepsClassName }), void 0));
};
Steps.Step = RcSteps.Step;
Steps.defaultProps = {
    current: 0,
};
export default Steps;
